module.exports = __webpack_public_path__ + "img/image.45f5646f.png";